<template>
	<JBox class="s-relative s-w-full s-h-16">
		<JBox class="s-flex s-h-full s-items-center s-w-full s-bg-white s-border-b s-border-gray-200 s-p-3">
			<!-- Logo -->
			<JFlex class="s-w-2/12 s-pl-2 s-items-center">
				<JHeadline class="s-text-gray-600 s-text-xl">
					<RouterLink :to="{ name: 'ViewDashboardHome' }">CoverGo Studio</RouterLink>
				</JHeadline>
			</JFlex>

			<!-- Nav -->
			<nav class="s-flex s-justify-center s-items-center s-pl-4 s-pr-4 s-w-8/12">
				<RouterLink :to="{ name: 'ViewAppsHome' }" :class="cls" :activeClass="activeCls">
					<svg :class="svgCls" stroke="currentColor" fill="none" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
						></path>
					</svg>
					Apps
				</RouterLink>
				<RouterLink :to="{ name: 'ViewTemplatesHome' }" :class="cls" :activeClass="activeCls">
					<svg :class="svgCls" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="template w-6 h-6">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
						></path>
					</svg>

					Templates
				</RouterLink>

				<RouterLink :to="{ name: 'ViewFilesHome' }" :class="cls" :activeClass="activeCls">
					<svg
						:class="svgCls"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
					</svg>
					Files
				</RouterLink>
			</nav>
			<JFlex class="s-w-2/12 s-items-center s-justify-end">
				<JBox>
					<JFlex
						class="s-items-center s-w-full s-h-full s-rounded-lg s-bg-gray-800 s-p-2 s-px-3 s-cursor-pointer"
						@click="showTenantSwitcher = true"
					>
						<JBox>
							<JBox class="s-text-xs s-text-gray-500 s-leading-3">Tenant</JBox>
							<JBox class="s-text-gray-200 s-leading-none s-text-sm s-leading-3">{{ currentTenantId }}</JBox>
						</JBox>
						<JFlex class="s-w-8 s-h-8 s-justify-center s-items-center s-ml-6">
							<CIcon name="chevron-down" class="s-text-gray-400 s-fill-current s-w-5 s-h-5" />
						</JFlex>
					</JFlex>
				</JBox>
			</JFlex>

			<!-- Tenant Modal -->
			<CModal :isVisible="showTenantSwitcher" @overlay:click="showTenantSwitcher = false" class="s-z-50">
				<JBox class="s-p-8">
					<JHeadline class="s-text-2xl s-text-gray-700">Actions</JHeadline>

					<JBox class="s-mt-6">
						<JFlex class="s-relative s-items-center s-border s-border-gray-300 s-bg-gray-50 s-rounded-lg s-p-4 s-mb-3">
							<JHeadline class="s-text-gray-700 s-text-lg s-leading-5 s-w-1/2">Log out</JHeadline>
							<JFlex class="s-mt-2 s-w-1/2 s-justify-end"><JButton variant="default-sm" @click="logOut">Log out</JButton></JFlex>
						</JFlex>
					</JBox>
				</JBox>
			</CModal>
		</JBox>
	</JBox>
</template>

<script>
import { cookieLogout } from "@/modules/auth/cookieMode.js"

export default {
	data() {
		return {
			showTenantSwitcher: false
		}
	},

	computed: {
		currentTenantId() {
			return this.$store?.state?.tenantId ?? ""
		},

		tenants() {
			return [
				{
					tenantId: "test",
					label: "Production",
					description: "Production environment. Your customers directly interact with this environment."
				},
				{
					tenantId: "test_uat",
					label: "Acceptance",
					description: "Acceptance environment. That's where users test the app."
				},
				{
					tenantId: "test_dev",
					label: "Development",
					description: "Where all the cahnges are being made."
				}
			]
		},

		cls() {
			return `s-mx-3 group s-flex s-items-center s-px-3 s-py-2 s-text-base s-leading-relaxed s-font-medium s-rounded-md  hover:s-text-white hover:s-bg-indigo-700 focus:s-outline-none focus:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150`
		},

		activeCls() {
			return `group s-flex s-mx-3 s-items-center s-px-3 s-py-2 s-text-sm s-text-white s-leading-5 s-font-medium s-rounded-md s-bg-indigo-700 hover:s-bg-indigo-700 focus:s-outline-none focus:s-bg-indigo-700 focus:s-text-white  `
		},

		svgCls() {
			return "s-mr-4 s-h-6 s-w-6  group-hover:s-text-white group-focus:s-text-white "
		}
	},

	methods: {
		goToManageEnvironments() {
			this.showTenantSwitcher = false
			this.$router.push({ name: "ViewReleasesHome" })
		},
		async logOut() {
			// CH-37826: revoke the BFF session too, or the SPA looks logged out while the
			// server-side session stays live. Self-gates, so legacy hosts are unaffected.
			await cookieLogout(this.$store.state.tenantId)
			localStorage.removeItem(process.env.VUE_APP_TOKEN_KEY)
			// The refresh token has to go as well: initApp only clears tokens when the
			// resolved host changes, so on the same host it would survive this logout and
			// fetcher.js could mint a fresh access token from it alone.
			localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN_KEY)
			window.location = `/`
		}
	}
}
</script>
